import React from 'react'
import IconButton from '@material-ui/core/IconButton';
import Chat from '@material-ui/icons/Chat'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';


const styles = theme => ({
    widget: {
        position: "fixed",
        right: "-3rem",
        bottom: "calc(-3rem + 60px)",
        zIndex: 100000,
        "@media (max-width: 490px)": {
            bottom: "130px",
        },
        "@media (max-height: 515px)": {
            bottom: "130px",
        }
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '6rem',
        height: '6rem',
        background: "#ffcb77",
        borderRadius: '50%',
        cursor: 'pointer',
        border: "solid #00325f 2px",
    },
    chat: {
        width: "90%",
        height: "90%",
        color: "#00325f",
    },
    textbubble: {
        position: "relative",
        right: "6.4rem",
        bottom: "11rem",
    },
    paper: {
        background: "rgb(255, 203, 119, 0.8)",
        color: "#00325f",
        borderRadius: 0,
        fontFamily: "'Lato',sans-serif",
        fontSize: "1.5rem",
        fontWeight: 600,
        padding: "0.8rem 1rem 0.8rem 0.8rem",
        userSelect: "none",
        cursor: "pointer"
    },
    arrowDown: {
        width: 0,
        height: 0,
        left: "8rem",
        borderLeft: "1.7rem solid transparent",
        borderRight: "0 solid transparent",
        borderTop: "1rem solid rgb(255, 203, 119, 0.8)",
        position: "relative",
        background: "transparent",
        userSelect: "none",
        cursor: "pointer"
    }
})

class Minimized extends React.Component {

    maximize = () => {
        this.props.maximize()
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.widget}>
                <div
                    className={classes.icon}
                    onClick={this.maximize}
                >
                    <IconButton className={classes.chat} title="Abrir asistente virtual">
                        <Chat style={{ width: "3rem", height: "3rem" }} />
                    </IconButton>
                </div>
                <div className={classes.textbubble}>
                    <div className={classes.paper} onClick={this.maximize} title="Te ayudamos. Abrir asistente virtual">Te ayudamos</div >
                    <div className={classes.arrowDown} onClick={this.maximize}></div>
                </div>
            </div>
        )
    }

}

Minimized.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Minimized);